import { IComboBoxOption } from "@fluentui/react";
import { trimNullableString } from "../../../services/SanitizationHelpers";
import { LineItemsPostBody } from "./LineItemsSchemas";

export const AccountTypeOptions: IComboBoxOption[] = [
  { key: "", text: "Choose an option" },
  { key: "Customer", text: "Customer (D)" },
  { key: "GL", text: "GL (S)" },
  { key: "Vendor", text: "Vendor (K)" }
];

const mapAccountTypeOutput = (inputAccountType: string): string => {
  let outputAccountType = trimNullableString(inputAccountType);
  const acc = AccountTypeOptions.slice(1).filter(
    (textValue) => textValue.text.toUpperCase() === outputAccountType.toUpperCase()
  );
  if (acc.length > 0) {
    outputAccountType = acc[0].key as string;
  }
  return outputAccountType;
};

export function sanitizeAndPackPostResponse(lineItemsList: string[][]): LineItemsPostBody[] {
  const cellHasData = (cellValue: string) => cellValue !== "" && cellValue !== undefined && cellValue !== null;
  const lineItems = lineItemsList.reduce((items, lineItemRow: string[]) => {
    if (Object.entries(lineItemRow).length === 0 && lineItemRow.constructor === Object) {
      // row is an empty object
      return items;
    } else if (lineItemRow.length !== 11) {
      // row has wrong number of columns
      return items;
    }
    if (lineItemRow.some(cellHasData)) {
      items.push({
        AccountType: mapAccountTypeOutput(lineItemRow[0]),
        Account: trimNullableString(lineItemRow[1]),
        CostCenter: trimNullableString(lineItemRow[2]),
        InternalOrder: trimNullableString(lineItemRow[3]),
        ProfitCenter: trimNullableString(lineItemRow[4]),
        TradingPartner: trimNullableString(lineItemRow[5]),
        MaterialGroup: trimNullableString(lineItemRow[6]),
        TaxCode: trimNullableString(lineItemRow[7]),
        TaxJurisdictionCode: trimNullableString(lineItemRow[8]),
        LineDesc: trimNullableString(lineItemRow[9]),
        LineAmount: trimNullableString(lineItemRow[10])
      });
    }
    return items;
  }, [] as LineItemsPostBody[]);
  return lineItems;
}

export const sanitizeInputToBlankOrInput = (theInput: string | null): string => {
  if (theInput !== null) {
    const newInput = theInput.trim();
    return newInput;
  }
  return "";
};
